/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBasicBbsContentPageListRespVo
 */
export interface GetBasicBbsContentPageListRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    id?: number;
    /**
     * 韩文标题
     * @type {string}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    title?: string;
    /**
     * 作者（按当前语言取中/韩文名）
     * @type {string}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    author?: string;
    /**
     * 员工id
     * @type {number}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    staffId?: number;
    /**
     * 员工姓名
     * @type {string}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    staffName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    updateTime?: string;
    /**
     * 发布时间
     * @type {string}
     * @memberof GetBasicBbsContentPageListRespVo
     */
    publishTime?: string;
}

/**
 * Check if a given object implements the GetBasicBbsContentPageListRespVo interface.
 */
export function instanceOfGetBasicBbsContentPageListRespVo(value: object): value is GetBasicBbsContentPageListRespVo {
    return true;
}

export function GetBasicBbsContentPageListRespVoFromJSON(json: any): GetBasicBbsContentPageListRespVo {
    return GetBasicBbsContentPageListRespVoFromJSONTyped(json, false);
}

export function GetBasicBbsContentPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBasicBbsContentPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'author': json['author'] == null ? undefined : json['author'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
        'staffName': json['staffName'] == null ? undefined : json['staffName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'publishTime': json['publishTime'] == null ? undefined : json['publishTime'],
    };
}

export function GetBasicBbsContentPageListRespVoToJSON(json: any): GetBasicBbsContentPageListRespVo {
    return GetBasicBbsContentPageListRespVoToJSONTyped(json, false);
}

export function GetBasicBbsContentPageListRespVoToJSONTyped(value?: GetBasicBbsContentPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'author': value['author'],
        'staffId': value['staffId'],
        'staffName': value['staffName'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'publishTime': value['publishTime'],
    };
}

